import { Search, SlidersHorizontal } from 'lucide-react';
import { ChangeEvent } from 'react';
import styles from './PatientSearchBar.module.css';

interface PatientSearchBarProps {
  query: string;
  onQueryChange: (v: string) => void;
  onFiltri?: () => void;
  resultCount: number;
}

export function PatientSearchBar({
  query,
  onQueryChange,
  onFiltri,
  resultCount,
}: PatientSearchBarProps) {
  return (
    <div className={styles.bar}>
      <div className={styles.searchWrap}>
        <Search size={16} strokeWidth={2.2} className={styles.searchIcon} />
        <input
          type="text"
          className={styles.input}
          placeholder="Cerca per nome, ID…"
          value={query}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onQueryChange(e.target.value)}
        />
      </div>
      <button className={styles.filtriBtn} type="button" onClick={onFiltri}>
        <SlidersHorizontal size={14} strokeWidth={2.4} />
        <span>Filtri</span>
      </button>
      <div className={styles.count}>
        {resultCount} {resultCount === 1 ? 'cliente' : 'clienti'}
      </div>
    </div>
  );
}
